module.exports = {
    'color-1': {
        name: 'Color 1',
        fillAll: true,
        placeholderColor: 'rgb(225, 223, 220)',
        border: [
          [0,0],
          [2, 0],
          [2, 2],
          [0, 2],
          [0, 0],
          [0, 2],
          [2, 2],
          [2, 4],
          [0, 4],
          [0, 2],
          [0, 4],
          [2, 4],
          [2, 6],
          [0, 6],
          [0, 4],
    
          [0, 12],
          [2, 12],
          [2, 14],
          [0, 14],
          [0, 12],
          [0, 14],
          [2, 14],
          [2, 16],
          [0, 16],
          [0, 14],
          [0, 16],
          [2, 16],
          [2, 18],
          [0, 18],
    
          [0, 24],
          [2, 24],
          [2, 26],
          [0, 26],
          [0, 24],
          [0, 26],
          [ 2, 26],
          [2, 28],
          [0, 28],
          [0, 26],
          [0, 28],
          [2, 28],
          [2, 30],
          [0, 30],
          [0, 28],
          [0, 24],
          [2, 24],
          [2, 30],
          [0, 30],
          [0, 24],
          [0, 30],
          
          [0, 36],
          [2, 36],
          [2, 38],
          [0, 38],
          [0, 36],
          [0, 38],
          [2, 38],
          [2, 40],
          [0, 40],
          [0, 38],
          [0, 40],
          [2, 40],
          [2, 42],
          [0, 42],
          [0, 36],
          [2, 36],
          [2, 42],
          [0, 42],
          [0, 36],
    
          [0, 48],
          [2, 48],
          [2, 50],
          [0, 50],
          [0, 48],
          [0, 50],
          [2, 50],
          [2, 52],
          [0, 52],
          [0, 50],
          [0, 52],
          [2, 52],
          [2, 54],
          [0, 54],
          [0, 48],
          [2, 48],
          [2, 54],
          [0, 54],
          [0, 48],
    
          [0, 60],
          [2, 60],
          [2, 62],
          [0, 62],
          [0, 60],
          [0, 62],
          [2, 62],
          [2, 64],
          [0, 64],
          [0, 62],
          [0, 64],
          [2, 64],
          [2, 66],
          [0, 66],
          [0, 60],
    
          [0, 72],
          [2, 72],
          [2, 74],
          [0, 74],
          [0, 72],
          [0, 74],
          [2, 74],
          [2, 76],
          [0, 76],
          [0, 74],
          [0, 76],
          [2, 76],
          [2, 78],
          [0, 78],
          [0, 72],
          [2, 72],
          [2, 78],
          [0, 78],
    
          [0, 84],
          [2, 84],
          [2, 86],
          [0, 86],
          [0, 84],
          [0, 86],
          [2, 86],
          [2, 88],
          [0, 88],
          [0, 86],
          [0, 88],
          [2, 88],
          [2, 90],
          [0, 90],
          [0, 84],
          [0, 0],
    
          [2, 0],
          [2, 6],
          [4, 6],
          [4, 6],
          [4, 8],
          [2, 8],
          [2, 6], 
          [2, 8],
          [4, 8],
          [4, 10],
          [2, 10],
          [2, 8],
          [2, 10],
          [4, 10],
          [4, 12],
          [2, 12],
    
          [2, 18],
          [4, 18],
          [4, 20],
          [2, 20],
          [2, 18],
          [2, 20],
          [4, 20],
          [4, 22],
          [2, 22],
          [2, 20],  
          [2, 22],
          [4, 22],
          [4, 24],
          [2, 24],
          [2, 18],
          [2, 24],
          [4, 24],
          [4, 26],
          [2, 26],
          [2, 24],
          
          [2, 30],
          [4, 30],
          [4, 32],
          [2, 32],
          [2, 30],
          [2, 32],
          [4, 32],
          [4, 34],
          [2, 34],
          [2, 32],
          [2, 34],
          [4, 34],
          [4, 36],
          [2, 36],
          [2, 30],
          [2, 36],
          [4, 36],
          [4, 38],
          [2, 38],
          [2, 36],
          [2, 30],
          
          [2, 42],
          [4, 42],
          [4, 44],
          [2, 44],
          [2, 42],
          [2, 44],
          [4, 44],
          [4, 46],
          [2, 46],
          [2, 44],
          [2, 46],
          [4, 46],
          [4, 48],
          [2, 48],
          [2, 42],
          [2, 48],
          [4, 48],
          [4, 50],
          [2, 50],
          [2, 48],
          [2, 42],
          
          [2, 54],
          [4, 54],
          [4, 56],
          [2, 56],
          [2, 54],
          [2, 56],
          [4, 56],
          [4, 58],
          [2, 58],
          [2, 56],
          [2, 58],
          [4, 58],
          [4, 60],
          [2, 60],
          [2, 54],
          [2, 60],
    
          [2, 66],
          [4, 66],
          [4, 68],
          [2, 68],
          [2, 66],
          [2, 68],
          [4, 68],
          [4, 70],
          [2, 70],
          [2, 68],
          [2, 70],
          [4, 70],
          [4, 72],
          [2, 72],
          [2, 66],
          [2, 72],
          [4, 72],
          [4, 74],
          [2, 74],
          
          [2, 78],
          [4, 78],
          [4, 80],
          [2, 80],
          [2, 78],
          [2, 80],
          [4, 80],
          [4, 82],
          [2, 82],
          [2, 80],
          [2, 82],
          [4, 82],
          [4, 84],
          [2, 84],
          [2, 78],
          [2, 84],
          [4, 84],
          [4, 86],
          [2, 86],
          [2, 84],
    
          [2, 90],
          [4, 90],
          [4, 92],
          [2, 92],
          [2, 90],
          [2, 92],
          [4, 92],
          [4, 94],
          [2, 94],
          [2, 92],
          [2, 94],
          [4, 94],
          [4, 96],
          [2, 96],
          [2, 90],
          [2, 0],
    
          [6, 0],
          [6, 2],
          [4, 2],
          [4, 0],
          [4, 2],
          [6, 2],
          [6, 4],
          [4, 4],
          [4, 2],
          [4, 4],
          [6, 4],
          [6, 6],
          [4, 6],
          [4, 4],
          [4, 0],
    
          [4, 12],
          [6, 12],
          [6, 14],
          [4, 14],
          [4, 12],
          [4, 14],
          [6, 14],
          [6, 16],
          [4, 16],
          [4, 14],
          [4, 16],
          [6, 16],
          [6, 18],
          [4, 18],
          [4, 12],
          [4, 18],
          [6, 18],
          [6, 20],
          [4, 20],
          [4, 18],
    
          [4, 24],
          [6, 24],
          [6, 26],
          [4, 26],
          [4, 24],
          [4, 26],
          [6, 26],
          [6, 28],
          [4, 28],
          [4, 26],
          [4, 28],
          [6, 28],
          [6, 30],
          [4, 30],
          [4, 24],
          [4, 30],
    
          [4, 36],
          [6, 36],
          [6, 38],
          [4, 38],
          [4, 36],
          [4, 38],
          [6, 38],
          [6, 40],
          [4, 40],
          [4, 38],
          [4, 40],
          [6, 40],
          [6, 42],
          [4, 42],
          [4, 36],
          [4, 42],
          [6, 42],
          [6, 44],
          [4, 44],
    
          [4, 48],
          [6, 48],
          [6, 50],
          [4, 50],
          [4, 48],
          [4, 50],
          [6, 50],
          [6, 52],
          [4, 52],
          [4, 50],
          [4, 52],
          [6, 52],
          [6, 54],
          [4, 54],
          [4, 48],
          [4, 54],
          [6, 54],
          [6, 56],
          [4, 56],
          [4, 54],
    
          [4, 60],
          [6, 60],
          [6, 62],
          [4, 62],
          [4, 60],
          [4, 62],
          [6, 62],
          [6, 64],
          [4, 64],
          [4, 62],
          [4, 64],
          [6, 64],
          [6, 66],
          [4, 66],
          [4, 60],
          [4, 66],
          [6, 66],
          [6, 68],
          [4, 68],
          [4, 66],
    
          [4, 72],
          [6, 72],
          [6, 74],
          [4, 74],
          [4, 72],
          [4, 74],
          [6, 74],
          [6, 76],
          [4, 76],
          [4, 74],
          [4, 76],
          [6, 76],
          [6, 78],
          [4, 78],
          [4, 72],
    
          [4, 84],
          [6, 84],
          [6, 86],
          [4, 86],
          [4, 84],
          [4, 86],  
          [6, 86],
          [6, 88],
          [4, 88],
          [4, 86],
          [4, 88],
          [6, 88],
          [6, 90],
          [4, 90],
          [4, 84],
          [4, 0],
    
          [6, 0],
          [6, 6],
          [8, 6],
          [8, 6],
          [8, 8],
          [6, 8],
          [6, 6],
          [6, 8],
          [8, 8],
          [8, 10],
          [6, 10],
          [6, 8],
          [6, 10],
          [8, 10],
          [8, 12],
          [6, 12],
    
          [6, 18],
          [8, 18],
          [8, 20],
          [6, 20],
          [6, 18],
          [6, 20],
          [8, 20],
          [8, 22],
          [6, 22],
          [6, 20],
          [6, 22],
          [8, 22],
          [8, 24],
          [6, 24],
          [6, 18],
          [6, 24],
          [8, 24],
          [8, 26],
          [6, 26],
          
          [6, 30],
          [8, 30],
          [8, 32],
          [6, 32],
          [6, 30],
          [6, 32],
          [8, 32],
          [8, 34],
          [6, 34],
          [6, 32],
          [6, 34],
          [8, 34],
          [8, 36],
          [6, 36],
          [6, 30],
    
          [6, 42],
          [8, 42],
          [8, 44],
          [6, 44],
          [6, 42],
          [6, 44],
          [8, 44],
          [8, 46],
          [6, 46],
          [6, 44],
          [6, 46],
          [8, 46],
          [8, 48],
          [6, 48],
          [6, 42],
          [6, 48],
          [8, 48],
          [8, 50],
          [6, 50],
          [6, 48],
          [6, 42],
          
          [6, 54],
          [8, 54],
          [8, 56],
          [6, 56],
          [6, 54],
          [6, 56],
          [8, 56],
          [8, 58],
          [6, 58],
          [6, 56],
          [6, 58],
          [8, 58],
          [8, 60],
          [6, 60],
          [6, 54],
          [6, 60],
          [8, 60],
          [8, 62],
          [6, 62],
          [6, 60],
          [6, 54],
    
          [6, 66],
          [8, 66],
          [8, 68],
          [6, 68],
          [6, 66],
          [6, 68],
          [8, 68],
          [8, 70],
          [6, 70],
          [6, 68],
          [6, 70],
          [8, 70],
          [8, 72],
          [6, 72],
          [6, 66],
          
          [6, 78],
          [8, 78],
          [8, 80],
          [6, 80],
          [6, 78],
          [6, 80],
          [8, 80],
          [8, 82],
          [6, 82],
          [6, 80],
          [6, 82],
          [8, 82],
          [8, 84],
          [6, 84],
          [6, 78],
    
          [6, 90],
          [8, 90],
          [8, 92],
          [6, 92],
          [6, 90],
          [6, 92],
          [8, 92],
          [8, 94],
          [6, 94],
          [6, 92],
          [6, 94],
          [8, 94],
          [8, 96],
          [6, 96],
          [6, 90],
          [6, 0],
    
          [10, 0],
          [10, 2],
          [8, 2],
          [8, 0],
          [8, 2],
          [10, 2],
          [10, 4],
          [8, 4],
          [8, 2],
          [8, 4],
          [10, 4],
          [10, 6],
          [8, 6],
          [8, 4],
          [8, 0],
    
          [8, 12],
          [10, 12],
          [10, 14],
          [8, 14],
          [8, 12],
          [8, 14],
          [10, 14],
          [10, 16],
          [8, 16],
          [8, 14],
          [8, 16],
          [10, 16],
          [10, 18],
          [8, 18],
          [8, 12],
    
          [8, 24],
          [10, 24],
          [10, 26],
          [8, 26],
          [8, 24],
          [8, 26],
          [10, 26],
          [10, 28],
          [8, 28],
          [8, 26],
          [8, 28],
          [10, 28],
          [10, 30],
          [8, 30],
          [8, 24],
    
          [8, 36],
          [10, 36],
          [10, 38],
          [8, 38],
          [8, 36],
          [8, 38],
          [10, 38],
          [10, 40],
          [8, 40],
          [8, 38],
          [8, 40],
          [10, 40],
          [10, 42],
          [8, 42],
          [8, 36],
    
          [8, 48],
          [10, 48],
          [10, 50],
          [8, 50],
          [8, 48],
          [8, 50],
          [10, 50],
          [10, 52],
          [8, 52],
          [8, 50],
          [8, 52],
          [10, 52],
          [10, 54],
          [8, 54],
          [8, 48],
    
          [8, 60],
          [10, 60],
          [10, 62],
          [8, 62],
          [8, 60],
          [8, 62],
          [10, 62],
          [10, 64],
          [8, 64],
          [8, 62],
          [8, 64],
          [10, 64],
          [10, 66],
          [8, 66],
          [8, 60],
          
          [8, 72],
          [10, 72],
          [10, 74],
          [8, 74],
          [8, 72],
          [8, 74],
          [10, 74],
          [10, 76],
          [8, 76],
          [8, 74],
          [8, 76],
          [10, 76],
          [10, 78],
          [8, 78],
          [8, 72],
    
          [8, 84],
          [10, 84],
          [10, 86],
          [8, 86],
          [8, 84],
          [8, 86],
          [10, 86],
          [10, 88],
          [8, 88],
          [8, 86],
          [8, 88],
          [10, 88],
          [10, 90],
          [8, 90],
          [8, 84],
    
          [8, 0],
          [10, 0],
    
          [10, 6],
          [12, 6],
          [12, 6],
          [12, 8],
          [10, 8],
          [10, 6],
          [10, 8],
          [12, 8],
          [12, 10],
          [10, 10],
          [10, 8],
          [10, 10],
          [12, 10],
          [12, 12],
          [10, 12],
          [10, 6],
    
          [10, 18],
          [12, 18],
          [12, 20],
          [10, 20],
          [10, 18],
          [10, 20],
          [12, 20],
          [12, 22],
          [10, 22],
          [10, 20],
          [10, 22],
          [12, 22],
          [12, 24],
          [10, 24],
          [10, 18],
    
          [10, 30],
          [12, 30],
          [12, 32],
          [10, 32],
          [10, 30],
          [10, 32],
          [12, 32],
          [12, 34],
          [10, 34],
          [10, 32],
          [10, 34],
          [12, 34],
          [12, 36],
          [10, 36],
          [10, 30],
    
          [10, 42],
          [12, 42],
          [12, 44],
          [10, 44],
          [10, 42],
          [10, 44],
          [12, 44],
          [12, 46],
          [10, 46],
          [10, 44],
          [10, 46],
          [12, 46],
          [12, 48],
          [10, 48],
          [10, 42],
    
          [10, 54],
          [12, 54],
          [12, 56],
          [10, 56],
          [10, 54],
          [10, 56],
          [12, 56],
          [12, 58],
          [10, 58],
          [10, 56],
          [10, 58],
          [12, 58],
          [12, 60],
          [10, 60],
          [10, 54],
    
          [10, 66],
          [12, 66],
          [12, 68],
          [10, 68],
          [10, 66],
          [10, 68],
          [12, 68],
          [12, 70],
          [10, 70],
          [10, 68],
          [10, 70],
          [12, 70],
          [12, 72],
          [10, 72],
          [10, 66],
    
          [10, 78],
          [12, 78],
          [12, 80],
          [10, 80],
          [10, 78],
          [10, 80],
          [12, 80],
          [12, 82],
          [10, 82],
          [10, 80],
          [10, 82],
          [12, 82],
          [12, 84],
          [10, 84],
          [10, 78],
    
          [10, 90],
          [12, 90],
          [12, 92],
          [10, 92],
          [10, 90],
          [10, 92],
          [12, 92],
          [12, 94],
          [10, 94],
          [10, 92],
          [10, 94],
          [12, 94],
          [12, 96],
          [10, 96],
          [10, 90],
    
          [10, 0],
        ]
    },
    'color-2': {
        name: 'Color 2',
        fillAll: true,
        placeholderColor: 'rgb(159, 160, 162)',
        border: [
          [0, 0],
          [0, 54],
          [2, 54],
          [2, 56],
          [0, 56],
          [0, 54],
          [0, 56],
          [2, 56],
          [2, 58],
          [0, 58],
          [0, 56],
          [0, 58],
          [2, 58],
          [2, 60],
          [0, 60],
          [0, 54],
    
          [2, 54],
          [2, 48],
          [4, 48],
          [4, 48],
          [4, 50],
          [2, 50],
          [2, 48],
          [2, 50],
          [4, 50],
          [4, 52],
          [2, 52],
          [2, 50],
          [2, 52],
          [4, 52],
          [4, 54],
          [2, 54],
          [2, 48],
          [4, 48],
          [4, 54],
          [2, 54],
          [0, 54],
    
          [6, 54],
          [6, 56],
          [4, 56],
          [4, 54],
          [4, 56],
          [6, 56],
          [6, 58],
          [4, 58],
          [4, 56],
          [4, 58],
          [6, 58],
          [6, 60],
          [4, 60],
          [4, 58],
          [4, 54],
    
          [6, 54],
          [6, 48],
          [8, 48],
          [8, 50],
          [6, 50],
          [6, 48],
          [6, 50],
          [8, 50],
          [8, 52],
          [6, 52],
          [6, 50],
          [6, 52],
          [8, 52],
          [8, 54],
          [6, 54],
          [6, 48],
          [8, 48],
          [8, 54],
    
          [10, 54],
          [10, 56],
          [8, 56],
          [8, 54],
          [8, 56],
          [10, 56],
          [10, 58],
          [8, 58],
          [8, 56],
          [8, 58],
          [10, 58],
          [10, 60],
          [8, 60],
          [8, 58],
          [8, 54],
    
          [10, 54],
          [ 10, 48], 
          [12, 48],
          [12, 50],
          [10, 50],
          [10, 48],
          [10, 50],
          [12, 50],
          [12, 52],
          [10, 52],
          [10, 50],
          [10, 52],
          [12, 52],
          [12, 54],
    
          [0, 54]
        ]
    },
    'color-3': {
        name: 'Color 3',
        fillAll: true,
        placeholderColor: 'rgb(149, 148, 144)',
        border: [
          [0, 0],
          [0, 42],
          [2, 42],
          [2, 44],
          [0, 44],
          [0, 42],
          [0, 44],
          [2, 44],
          [2, 46],
          [0, 46],
          [0, 44],
          [0, 46],
          [2, 46],
          [2, 48],
          [0, 48],
          [0, 42],
          [2, 42],
          [2, 48],
          [0, 48],
          [0, 42],
          
          [2, 42],
          [2, 36],
          [4, 36],
          [4, 36],
          [4, 38],
          [2, 38],
          [2, 36],
          [2, 38],
          [4, 38],
          [4, 40],
          [2, 40],
          [2, 38],
          [2, 40],
          [4, 40],
          [4, 42],
          [2, 42],
          [2, 36],
          [4, 36],
          [4, 42],
          [2, 42],
          [0, 42],
    
          [6, 42],
          [6, 44],
          [4, 44],
          [4, 42],
          [4, 44],
          [6, 44],
          [6, 46],
          [4, 46],
          [4, 44],
          [4, 46],
          [6, 46],
          [6, 48],
          [4, 48],
          [4, 46],
          [ 4, 42],
    
          [6, 42],
          [6, 36],
          [8, 36],
          [8, 38],
          [6, 38],
          [6, 36],
          [6, 38],
          [8, 38],
          [8, 40],
          [6, 40],
          [6, 38],
          [6, 40],
          [8, 40],
          [8, 42],
          [6, 42],
    
          [10, 42],
          [10, 44],
          [8, 44],
          [8, 42],
          [8, 44],
          [10, 44],
          [10, 46],
          [8, 46],
          [8, 44],
          [8, 46],
          [10, 46],
          [10, 48],
          [8, 48],
          [8, 46],
          [8, 42],
          
          [10, 42],
          [10, 36],
          [12, 36],
          [12, 38],
          [10, 38],
          [10, 36],
          [10, 38],
          [12, 38],
          [12, 40],
          [10, 40],
          [10, 38],
          [10, 40],
          [12, 40],
          [12, 42],
          [0, 42],
    
          [0, 66],
          [2, 66],
          [2, 68],
          [0, 68],
          [0, 66],
          [0, 68],
          [2, 68],
          [2, 70],
          [0, 70],
          [0, 68],
          [0, 70],
          [ 2, 70],
          [2, 72],
          [0, 72],
          [0, 66],
          [2, 66],
          [2, 72],
          [0, 72],
          [0, 66],
    
          [2, 66],
          [2, 60],
          [4, 60],
          [4, 60],
          [4, 62],
          [2, 62],
          [2, 60],
          [2, 62],
          [4, 62],
          [4, 64],
          [2, 64],
          [2, 62],
          [2, 64],
          [4, 64],
          [4, 66],
          [2, 66],
          [0, 66],
    
          [6, 66],
          [6, 68],
          [4, 68],
          [4, 66],
          [4, 68],
          [6, 68],
          [6, 70],
          [4, 70],
          [4, 68],
          [4, 70],
          [6, 70],
          [6, 72],
          [4, 72],
          [4, 70],
          [4, 66],
    
          [6, 66],
          [6, 60],
          [8, 60],
          [8, 62],
          [6, 62],
          [6, 60],
          [6, 62],
          [8, 62],
          [8, 64],
          [6, 64],
          [6, 62],
          [6, 64],
          [8, 64],
          [8, 66],
          [6, 66],
    
          [10, 66],
          [10, 68],
          [8, 68],
          [8, 66],
          [8, 68],
          [10, 68],
          [10, 70],
          [8, 70],
          [8, 68],
          [8, 70],
          [10, 70],
          [10, 72],
          [ 8, 72],
          [8, 70],
          [8, 66],
    
          [10, 66],
          [10, 60],
          [12, 60],
          [12, 62],
          [10, 62],
          [10, 60],
          [10, 62],
          [12, 62],
          [12, 64],
          [10, 64],
          [10, 62],
          [10, 64],
          [12, 64],
          [12, 66],
          [0, 66]
        ]
    },
    'color-4': {
        name: 'Color 4',
        fillAll: true,
        placeholderColor: 'rgb(152, 150, 156)',
        border: [
          [0, 0],
          [0, 30],
          [2, 30],
          [2, 32],
          [0, 32],
          [0, 30],
          [0, 32],
          [2, 32],
          [2, 34],
          [0, 34],
          [0, 32],
          [0, 34],
          [2, 34],
          [2, 36],
          [0, 36],
          [0, 30],
    
          [2, 30],
          [2, 24],
          [ 4, 24],
          [4, 24],
          [4, 26],
          [2, 26],
          [2, 24],
          [2, 26],
          [4, 26],
          [4, 28],
          [2, 28],
          [2, 26],
          [ 2, 28],
          [4, 28],
          [4, 30],
          [2, 30],
    
          [6, 30],
          [6, 32],
          [4, 32],
          [4, 30],
          [4, 32],
          [6, 32],
          [6, 34],
          [4, 34],
          [4, 32],
          [4, 34],
          [6, 34],
          [6, 36],
          [4, 36],
          [4, 34],
          [4, 30],
    
          [6, 30],
          [6, 24],
          [8, 24],
          [8, 26],
          [6, 26],
          [6, 24],
          [6, 26],
          [8, 26],
          [8, 28],
          [6, 28],
          [6, 26],
          [6, 28],
          [8, 28],
          [8, 30],
          [6, 30],
          [6, 24],
          [8, 24],
          [8, 30],
    
          [10, 30],
          [10, 32],
          [8, 32],
          [8, 30],
          [8, 32],
          [10, 32],
          [10, 34],
          [8, 34],
          [8, 32],
          [8, 34],
          [10, 34],
          [10, 36],
          [8, 36],
          [8, 34],
          [8, 30],
          
          [10, 30],
          [10, 24],
          [12, 24],
          [12, 26],
          [10, 26],
          [10, 24],
          [10, 26],
          [12, 26],
          [12, 28],
          [10, 28],
          [10, 26],
          [10, 28],
          [12, 28],
          [12, 30],
          [10, 30],
          [10, 24],
          [12, 24],
          [12, 30],
          [10, 30],
          [0, 30],
    
          [0, 78],
          [2, 78],
          [2, 80],
          [0, 80],
          [0, 78],
          [0, 80],
          [2, 80],
          [2, 82],
          [0, 82],
          [0, 80],
          [0, 82],
          [2, 82],
          [2, 84],
          [0, 84],
          [0, 78],
    
          [2, 78],
          [2, 72],
          [ 4, 72],
          [4, 72],
          [4, 74],
          [2, 74],
          [2, 72],
          [2, 74],
          [ 4, 74],
          [4, 76],
          [2, 76],
          [2, 74],
          [ 2, 76],
          [4, 76],
          [4, 78],
          [2, 78],
    
          [6, 78],
          [6, 80],
          [4, 80],
          [4, 78],
          [4, 80],
          [6, 80],
          [6, 82],
          [4, 82],
          [4, 80],
          [4, 82],
          [6, 82],
          [6, 84],
          [ 4, 84],
          [4, 82],
          [4, 78],
          [6, 78],
    
          [6, 78],
          [6, 72],
          [8, 72],
          [8, 74],
          [6, 74],
          [6, 72],
          [6, 74],
          [8, 74],
          [8, 76],
          [6, 76],
          [6, 74],
          [6, 76],
          [8, 76],
          [8, 78],
          [6, 78],
          [6, 72],
          [8, 72],
          [8, 78],
    
          [10, 78],
          [10, 80],
          [8, 80],
          [8, 78],
          [8, 80],
          [10, 80],
          [10, 82],
          [8, 82],
          [8, 80],
          [8, 82],
          [10, 82],
          [10, 84],
          [8, 84],
          [8, 82],
          [8, 78],
          [10, 78],
          [10, 84],
          [8, 84],
          [8, 78],
    
          [10, 78],
          [10, 72],
          [12, 72],
          [12, 74],
          [10, 74],
          [10, 72],
          [10, 74],
          [12, 74],
          [12, 76],
          [10, 76],
          [10, 74],
          [10, 76],
          [12, 76],
          [12, 78],
          [10, 78],
          [10, 72],
          [12, 72],
          [12, 78],
          [0, 78],
        ]
    },
    'color-5': {
        name: 'Color 5',
        fillAll: true,
        placeholderColor: 'rgb(106, 105, 111)',
        border: [
          [0, 0],
          [0, 18], 
          [2, 18],
          [2, 20],
          [0, 20],
          [0, 18],
          [0, 20],
          [2, 20],
          [2, 22],
          [0, 22],
          [0, 20],
          [0, 22],
          [2, 22],
          [2, 24],
          [0, 24],
          [0, 12],
    
          [4, 12],
          [4, 14],
          [2, 14],
          [2, 12],
          [2, 14],
          [4, 14],
          [4, 16],
          [2, 16],
          [2, 14],
          [ 2, 16],
          [4, 16],
          [4, 18],
          [2, 18],
          [2, 16],
          [2, 12],
          [4, 12],
        [4, 18],
        [6, 18],
        [6, 20],
        [4, 20],
        [4, 18],
        [4, 20],
        [6, 20],
        [6, 22],
        [4, 22],
        [4, 20],
        [4, 22],
        [6, 22],
        [6, 24],
        [4, 24],
        [4, 18],
        [6, 18],
        [4, 18],
        [4, 12],
    
        [8, 12],
        [8, 14],
        [6, 14],
        [6, 12],
        [6, 14],
        [8, 14],
        [8, 16],
        [6, 16],
        [6, 14],
        [6, 16],
        [8, 16],
        [8, 18],
        [6, 18],
        [6, 16],
    
        [6, 12],
        [8, 12],
        [8, 18],
        [10, 18],
          [10, 20],
          [8, 20],
          [8, 18],
          [8, 20],
          [10, 20],
          [10, 22],
          [8, 22],
          [8, 20],
          [8, 22],
          [10, 22],
          [10, 24],
          [8, 24],
          [8, 18],
          [10, 18],
          [8, 18],
          [8, 12],
          [12, 12],
          [12, 14],
          [10, 14],
          [10, 12],
          [10, 14],
          [12, 14],
          [12, 16],
          [10, 16],
          [10, 14],
          [10, 16],
          [12, 16],
          [12, 18],
          [10, 18],
          [10, 16],
          [10, 12],
          [0, 12],
    
          [0, 0],
          [0, 90],
          [2, 90],
          [2, 92],
          [0, 92],
          [0, 90],
          [0, 92],
          [2, 92],
          [2, 94],
          [0, 94],
          [ 0, 92],
          [0, 94],
          [2, 94],
          [2, 96],
          [0, 96],
          [0, 94],
    
          [0, 84],
          [4, 84],
          [4, 86],
          [2, 86],
          [2, 84],
          [2, 86],
          [4, 86],
          [4, 88],
          [2, 88],
          [2, 86],
          [2, 88],
          [ 4, 88],
          [4, 90],
          [2, 90],
          [2, 84],
          [0, 84],
    
          [4, 84],
          [4, 90],
          [6, 90],
          [6, 92],
          [4, 92],
          [4, 90],
          [4, 92],
          [6, 92],
          [6, 94],
          [4, 94],
          [4, 92],
          [4, 94],
          [6, 94],
          [ 6, 96],
          [4, 96],
          [4, 84],
          [8, 84],
          [8, 86],
          [6, 86],
          [6, 84],
          [6, 86],
          [8, 86],
          [8, 88],
          [6, 88],
          [6, 86],
          [6, 88],
          [8, 88],
          [8, 90],
          [6, 90],
          [6, 88],
          [6, 84],
          [8, 84],
    
          [8, 90],
          [10, 90],
          [10, 92],
          [ 8, 92],
          [8, 90],
          [8, 92],
          [10, 92],
          [10, 94],
          [8, 94],
          [8, 92],
          [8, 94],
          [10, 94],
          [10, 96],
          [8, 96],
          [8, 90],
          [8, 84],
    
          [12, 84],
          [12, 86],
          [10, 86],
          [10, 84],
          [10, 86],
          [12, 86],
          [12, 88],
          [10, 88],
          [10, 86],
          [10, 88],
          [12, 88],
          [12, 90],
          [10, 90],
          [10, 88],
          [10, 84],
          [12, 84],
          [12, 90],
          [10, 90],
          [10, 84],
          [0, 84],
          
        ]      
    },
    'color-6': {
        name: 'Color 6',
        fillAll: true,
        placeholderColor: 'rgb(60,64,70)',
        border: [
          [0, 0],
          [0, 6],
          [2, 6], 
          [2, 8],
          [0, 8],
          [0, 6],
          [0, 8],
          [2, 8],
          [2, 10],
          [0, 10],
          [0, 8],
          [0, 10],
          [2, 10],
          [2, 12],
          [0, 12],
          [0, 10],
          [0, 0],
          [4, 0],
          [4, 2],
          [2, 2],
          [2, 0],
          [2, 2],
          [4, 2],
          [4, 4],
          [2, 4],
          [2, 2],
          [2, 4],
          [4, 4],
          [4, 6],
          [2, 6],
          [2, 4],
          [2, 6],
          [2, 0],
          [4, 0],
    
          [4, 6],
          [6, 6],
          [6, 8],
          [4, 8],
          [4, 6],
          [4, 8],
          [6, 8],
          [6, 10],
          [4, 10],
          [4, 8],
          [4, 10],
          [6, 10],
          [6, 12],
          [4, 12],
          [4, 10],
          [4, 0],
    
          [8, 0],
          [8, 2],
          [6, 2],
          [6, 0],
          [6, 2],
          [8, 2],
          [8, 4],
          [6, 4],
          [6, 2],
          [6, 4],
          [8, 4],
          [8, 6],
          [6, 6],
          [6, 4],
          [6, 0],
          [8, 0],
          [8, 6],
          [10, 6],
          [10, 8],
          [8, 8],
          [8, 6],
          [8, 8],
          [10, 8],
          [10, 10],
          [8, 10],
          [8, 8],
          [8, 10],
          [10, 10],
          [10, 12],
          [8, 12],
          [8, 10],
          [8, 0],
          [12, 0],
          [12, 2],
          [10, 2],
          [10, 0],
          [10, 2],
          [12, 2],
          [12, 4],
          [10, 4],
          [10, 2],
          [10, 4],
          [12, 4],
          [12, 6],
          [10, 6],
          [10, 4],
          [10, 0],
         
        ]      
    }
}


// WEBPACK FOOTER //
// ./src/universal/filzfelt/blocks/checker.js